module.exports = __webpack_public_path__ + "img/happy 1.e0bd3268.png";